<template>
    <h3 class="mealTitle">Few words about the project...</h3>
    <h4>Authors:</h4>
    <p>Web application: Łukasz Kuczma</p>
    <p>Desktop application: Maciej Karpiński</p>
</template>

<script>
export default {

}
</script>

<style>

</style>